// extracted by mini-css-extract-plugin
export default {"contacts":"contacts_contacts__xPwhn","links":"contacts_links__UdTuL","link":"contacts_link__4xSz6"};